import React from 'react';
import { PropTypes } from 'prop-types';
import {
  deliveryNotesFileExtensionsButton,
  laboratoryFileExtensionsButton,
} from '../../constants/general';
import styles from './index.module.scss';

const AccionaBigUploadButton = ({ onClick, msg, icon, type, id, disabled }) => (
  <div
    className={`home-button ${styles.wrapper} ${icon} ${
      disabled ? 'disabled' : ''
    }`}
  >
    {/* eslint-disable-next-line*/}
    <a
      className="home-button"
      onClick={() => {
        if (!disabled) fileUploadHandler(icon, id);
      }}
      id="AccionaBigUploadButton"
    >
      <div className="image-btn"> </div>
      <input
        accept={
          type === 'deliveryNote'
            ? deliveryNotesFileExtensionsButton
            : laboratoryFileExtensionsButton
        }
        hidden
        id={id || `fileSelector_${icon}`}
        type="file"
        onChange={onClick}
        multiple="multiple"
      />
      <span> {msg}</span>
    </a>
  </div>
);

const fileUploadHandler = (icon, id) => {
  document.getElementById(id || `fileSelector_${icon}`).click();
};

AccionaBigUploadButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  msg: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf(['deliveryNote', 'laboratory']).isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

AccionaBigUploadButton.defaultProps = {
  onClick: () => {},
  msg: 'UPLOAD',
  icon: 'data',
  id: null,
  disabled: false,
};

export default AccionaBigUploadButton;
